import {useAppSelector} from '../store/hooks';
import {EUserRoles} from '../enums/roles';

const IsAdmin =() => {
    const {user} = useAppSelector(state => state.auth);
    return user?.role === EUserRoles.ADMIN;
};
export default IsAdmin;
